import Check from "@mui/icons-material/Check";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import styled from "styled-components";
export const StyledAutocomplete = styled(Autocomplete) `
    .MuiInputAdornment-positionStart {
        width: 24px;
        height: 24px;
        margin: 0 0 0 6px;
    }
`;
export const AutocompleteMenuItem = styled.li `
    // Default autocomplete component prevents clicks with pointer-events: none, but we need to
    // revert that so that tooltips work on disabled items. Instead we suppress clicks in the click handler.
    &&[aria-disabled="true"] {
        pointer-events: initial;
    }
`;
export const StyledAutocompletePopper = styled(Popper) ``;
export const MenuCheck = styled(Check) `
    margin-left: auto;
`;
